import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Swal from "sweetalert2";
import { passwordsMustMatchMsg, tokenProvidedNotValid, passResetSuccess, passwordReqMsg } from "../../global/popupMessages";
import userService from "../../Services/userService";
import bquickLogo from "../../assets/images/bquick-logo.png";
import { Link } from "react-router-dom";

export default class SetNewPass extends Component {
  state = {
    pass: "",
    repeatPass: "",
    token: "",
    email: ""
  };

  componentDidMount() {
    var token = this.props.match.params.token;
    var email = this.props.match.params.clientEmail;
    this.setState({ token, email });
  }

  render() {
    return (
      <div className="mt-120">
        <div className="container-sm-custom center">
          <div className="col-sm-12 center">
            <Link to="/login">
              <img width="150" src={bquickLogo} />
            </Link>
          </div>
          <Card>
            <CardContent className="login-card">
              <div className="mb-20">
                <h4>
                  <b>הגדרת סיסמה חדשה</b>
                </h4>
                <form>
                  <div className="padding10">
                    <TextField className="width80" required id="pass" onChange={this.handleChange} label="סיסמה" type="password" />
                  </div>
                  <div className="mb-30 padding10">
                    <TextField
                      className="width80"
                      id="repeatPass"
                      onChange={this.handleChange}
                      required
                      label="אישור סיסמה"
                      type="password"
                    />
                  </div>

                  <div className="mt-50">
                    <Button className="white-btn-txt" color="primary" variant="contained" onClick={this.handleSubmit}>
                      שמור
                    </Button>
                  </div>
                </form>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.pass.length < 6 || this.state.repeatPass.length < 6) {
      Swal.fire("", passwordReqMsg, "warning");
      return;
    }
    if (this.state.pass !== this.state.repeatPass) {
      Swal.fire("", passwordsMustMatchMsg, "warning");
      return;
    } else if (!this.state.token || !this.state.email) {
      Swal.fire("", "missing data", "warning");
      return;
    }
    var takeVars = this.state;
    userService.changePass(takeVars.email, takeVars.pass, takeVars.token).then((res) => {
      if (!res["isTokenValid"]) {
        Swal.fire("", tokenProvidedNotValid, "warning");
      } else if (res["success"]) {
        Swal.fire("", passResetSuccess, "success").then(() => {
          this.props.history.push("/");
        });
      }
    });
  };
}
